import React from 'react'
import { MAX_WIDTH, SLIM_TIPSTER_URL } from '@config'

const tipsterCreator = () => (<iframe src={SLIM_TIPSTER_URL} width={MAX_WIDTH} height={'100%'} />)

export default tipsterCreator
